import type { DeleteLineItemResponse } from '@vy/api-definition';
import { DeleteLineItemResponseSchema } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type DeleteLineItemRequest = Parameters<WeftApi['deleteLineItemRaw']>[0];

export function useDeleteLineItem(
  options?: UseMutationOptions<DeleteLineItemResponse, unknown, DeleteLineItemRequest>,
) {
  return useMutation({
    mutationFn: async ({ lineItemId }) => {
      const lineItemsApi = getPrivateApi();
      const deleteLineItemResponse = await lineItemsApi.deleteLineItem({
        lineItemId,
      });

      return DeleteLineItemResponseSchema.parse(deleteLineItemResponse);
    },
    ...options,
  });
}
